<app-page-loader></app-page-loader>
<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>

